import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { createStore } from "redux";
import { LoginProvider } from "./context/login.context";
import reducers from "./redux/reducers";

const Root = ({ children }: { children: JSX.Element }) => (
  <BrowserRouter>
    <Provider store={createStore(reducers)}>
      <LoginProvider>{children}</LoginProvider>
    </Provider>
  </BrowserRouter>
);

export default Root;
